import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { FeaturesProvider } from './context/FeaturesContext';
import { AddonsProvider } from './context/AddonsContext';
import { NotificationsProvider } from './context/NotificationsContext';
import ErrorBoundary from './components/ErrorBoundary';
import { customerTheme } from './theme/customerTheme';
import './styles/index.css';
// Geist and Geist Mono, self-hosted (no external font CDN), and the design's colours for the
// libraries MUI's theme cannot reach. The management console's entry loads neither.
import './styles/customer.css';

const routerFutureFlags = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// AuthProvider must be outside StrictMode to prevent keycloak-js initialization issues
// This is a known issue with React 18 StrictMode and keycloak-js.
root.render(
  <AuthProvider>
    <React.StrictMode>
      <BrowserRouter future={routerFutureFlags}>
        <ThemeProvider buildTheme={customerTheme}>
          <NotificationsProvider>
            <ErrorBoundary fullPage>
              <FeaturesProvider>
                <AddonsProvider>
                  <App />
                </AddonsProvider>
              </FeaturesProvider>
            </ErrorBoundary>
          </NotificationsProvider>
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
  </AuthProvider>
);
